export default __webpack_public_path__ + "static/media/fireworks.9b2eef60.svg";